import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useTheme } from "../context/ThemeContext";
import { motion } from "framer-motion";
import PrivacyConfirmModal from "./PrivacyConfirmModal";

const Hero: React.FC = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCTAClick = () => {
    setIsModalOpen(true);
  };

  const handleConfirm = () => {
    const formUrl = language === "en" 
      ? 'https://tally.so/r/wvJ2jl'
      : 'https://tally.so/r/nPb4oQ';
    const win = window.open(formUrl, 'DynovantContactForm', 'noopener,noreferrer');
    if (win) win.opener = null;
    setIsModalOpen(false);
  };

  const renderTitle = () => {
    const textColor = theme === "dark" ? "text-white" : "text-gray-800";
    const highlightColor = "text-green-500";

    if (language === "en") {
      return (
        <>
          <span className={textColor}>Your </span>
          <span className={highlightColor}>Analysis</span>
          <span className={textColor}>, </span>
          <span className={highlightColor}>Optimization</span>
          <span className={textColor}> and </span>
          <span className={highlightColor}>Automation</span>
          <span className={textColor}> Partner</span>
        </>
      );
    }
    return (
      <>
        <span className={textColor}>Votre Partenaire en </span>
        <span className={highlightColor}>Analyse</span>
        <span className={textColor}>, </span>
        <span className={highlightColor}>Optimisation</span>
        <span className={textColor}> et </span>
        <span className={highlightColor}>Automatisation</span>
      </>
    );
  };

  return (
    <>
      <section className="min-h-screen flex items-center justify-center pt-16 relative z-10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center relative z-10">
          <motion.h1
            className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 lg:mb-8 ${
              theme === "dark" ? "text-gray-200" : "text-gray-900"
            }`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            {renderTitle()}
          </motion.h1>
          <motion.p
            className={`text-lg sm:text-xl md:text-2xl max-w-3xl mx-auto mb-8 sm:mb-10 lg:mb-12 ${
              theme === "dark" ? "text-gray-300" : "text-gray-900"
            }`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            {language === "en"
              ? "Empower your business to streamline operations, reduce costs, and gain a competitive edge using our advanced digital transformation and AI solutions."
              : "Donnez à votre entreprise les moyens de rationaliser ses opérations, de réduire ses coûts et d'obtenir un avantage concurrentiel grâce à nos solutions avancées de transformation digitale et d'IA."}
          </motion.p>
          <motion.button
            className={`px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-lg sm:text-xl font-semibold hover:bg-green-400 transition-colors bg-green-500 text-black`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
            onClick={handleCTAClick}
          >
            {language === "en" ? "Book a Free Consultation" : "Réserver une Consultation Gratuite"}
          </motion.button>
        </div>
      </section>

      <PrivacyConfirmModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default Hero;
